import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withKeys as _withKeys, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "preg__main" }
const _hoisted_2 = { class: "preg__intro" }
const _hoisted_3 = { class: "preg__title" }
const _hoisted_4 = { class: "preg__card" }
const _hoisted_5 = { class: "preg__field" }
const _hoisted_6 = {
  class: "preg__kinds",
  role: "radiogroup",
  "aria-label": "판매 구분"
}
const _hoisted_7 = {
  key: 0,
  class: "preg__hint"
}
const _hoisted_8 = {
  key: 1,
  class: "preg__hint"
}
const _hoisted_9 = { class: "preg__field" }
const _hoisted_10 = { class: "preg__field" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  class: "preg__field",
  "data-tour": "seller-product-origin"
}
const _hoisted_13 = { class: "preg__label" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  class: "preg__radios",
  role: "radiogroup",
  "aria-label": "원산지"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "preg__origin-detail"
}
const _hoisted_18 = {
  key: 1,
  class: "preg__origin-detail"
}
const _hoisted_19 = {
  key: 2,
  class: "preg__origin-detail"
}
const _hoisted_20 = { class: "preg__hint" }
const _hoisted_21 = {
  key: 0,
  class: "preg__field"
}
const _hoisted_22 = ["value", "checked", "onClick", "onKeydown"]
const _hoisted_23 = { class: "preg__field" }
const _hoisted_24 = { class: "preg__field" }
const _hoisted_25 = { class: "preg__images" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 0,
  class: "preg__image-badge"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "preg__field" }
const _hoisted_31 = { class: "preg__locked" }
const _hoisted_32 = {
  key: 1,
  class: "preg__unit"
}
const _hoisted_33 = {
  class: "preg__card",
  "data-tour": "seller-product-detail"
}
const _hoisted_34 = { class: "preg__card-head" }
const _hoisted_35 = { class: "preg__hint" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "preg__note"
}
const _hoisted_38 = {
  key: 1,
  class: "preg__blocks"
}
const _hoisted_39 = { class: "preg__block-head" }
const _hoisted_40 = { class: "preg__block-tools" }
const _hoisted_41 = ["disabled", "onClick"]
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = ["onUpdate:modelValue", "rows", "placeholder"]
const _hoisted_46 = {
  key: 2,
  class: "preg__block-image"
}
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = {
  key: 1,
  class: "preg__block-thumb"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "preg__block-image-side" }
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "preg__block-add" }
const _hoisted_54 = {
  class: "preg__card",
  "data-tour": "product-editor-shipping"
}
const _hoisted_55 = { class: "preg__stack" }
const _hoisted_56 = { class: "preg__field" }
const _hoisted_57 = { class: "preg__lead-picks" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "preg__card" }
const _hoisted_60 = { class: "preg__stack" }
const _hoisted_61 = { class: "preg__field" }
const _hoisted_62 = { class: "preg__ship-line" }
const _hoisted_63 = { class: "preg__ship-chunk" }
const _hoisted_64 = { class: "preg__ship-chunk preg__ship-chunk--fee" }
const _hoisted_65 = { class: "preg__field" }
const _hoisted_66 = { class: "preg__label" }
const _hoisted_67 = { class: "preg__unit" }
const _hoisted_68 = { class: "preg__field" }
const _hoisted_69 = { class: "preg__label" }
const _hoisted_70 = { class: "preg__unit" }
const _hoisted_71 = {
  key: 0,
  class: "preg__hint"
}
const _hoisted_72 = { "data-tour": "product-editor-sell" }
const _hoisted_73 = { class: "preg__field" }
const _hoisted_74 = { class: "preg__unit" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = {
  key: 0,
  class: "preg__hint"
}
const _hoisted_77 = { class: "preg__qty-add" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = ["disabled"]
const _hoisted_80 = { class: "preg__qty-custom" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = ["disabled"]
const _hoisted_83 = {
  key: 0,
  class: "preg__hint"
}
const _hoisted_84 = {
  key: 1,
  class: "preg__hint"
}
const _hoisted_85 = {
  key: 2,
  class: "preg__opt-list"
}
const _hoisted_86 = { class: "preg__front" }
const _hoisted_87 = ["checked", "disabled", "aria-label", "onChange"]
const _hoisted_88 = { class: "preg__qty-price" }
const _hoisted_89 = {
  key: 0,
  class: "preg__front-mark"
}
const _hoisted_90 = ["disabled", "aria-label", "onClick"]
const _hoisted_91 = {
  key: 0,
  class: "preg__opt-note"
}
const _hoisted_92 = {
  key: 1,
  class: "preg__opt-note"
}
const _hoisted_93 = {
  key: 2,
  class: "preg__opt-note"
}
const _hoisted_94 = { class: "preg__margin-note" }
const _hoisted_95 = { class: "preg__card" }
const _hoisted_96 = { class: "preg__field" }
const _hoisted_97 = {
  class: "preg__preview",
  "data-tour": "seller-product-preview-map"
}
const _hoisted_98 = {
  class: "preg__preview-tabs",
  role: "tablist",
  "aria-label": "상품 미리보기"
}
const _hoisted_99 = ["aria-selected"]
const _hoisted_100 = ["aria-selected"]
const _hoisted_101 = {
  class: "preg__preview-pane",
  role: "tabpanel"
}
const _hoisted_102 = {
  class: "preg__preview-pane",
  role: "tabpanel"
}

import { computed, nextTick, onMounted, ref, watch } from 'vue'
import type { UploadedImage } from '@/api/mallProduct'
import AppIcon from '@/components/common/AppIcon.vue'
import WonInput from '@/components/manage/WonInput.vue'
import MallProductBuyPanel from '@/components/mall/MallProductBuyPanel.vue'
import ProductCard from '@/components/mall/ProductCard.vue'
import type { MallDetailBlock } from '@/constants/mallProducts'
import {
  BLOCK_LABEL,
  LEAD_TIMES,
  MAX_PRODUCT_IMAGES,
  ORIGIN_KIND_OPTIONS,
  composeOrigin,
  applySaleCarton,
  DEFAULT_MARGIN_SHARE,
  nextRowKey,
  originRequiredFor,
  toPreviewProduct,
  type EditorOption,
  type OriginKind,
  type ProductEditorForm,
} from '@/constants/productEditor'
import { optionPieceCount, sellUnitNoun } from '@/utils/mallSell'
import { packQuoteReady, quotePack, suggestPackQtys, type PackQuote } from '@/utils/mallPackQuote'

type MallKind = 'REGULAR' | 'SALE'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductRegisterSheet',
  props: {
    form: {},
    tone: { default: 'seller' },
    storeName: { default: '' },
    categories: {},
    uploader: {},
    storeShipping: {},
    storeShippingReadonly: { type: Boolean, default: false },
    stockLocked: { type: Boolean, default: false },
    saleStatus: { default: '' },
    canEditStatus: { type: Boolean, default: false },
    isNew: { type: Boolean, default: true }
  },
  emits: ["notify", "open-stock-history", "update-status"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const saleStatusChoices = [
  { value: 'SELLING', label: '판매중' },
  { value: 'SOLDOUT', label: '품절' },
  { value: 'HIDDEN', label: '판매중지' },
] as const

const statusRadioName = `preg-sale-status-${Math.random().toString(36).slice(2, 8)}`
const statusRadioRoot = ref<HTMLElement | null>(null)

function syncSaleStatusRadios() {
  const root = statusRadioRoot.value
  if (!root) return
  root.querySelectorAll<HTMLInputElement>('input[type="radio"]').forEach((input) => {
    input.checked = input.value === props.saleStatus
  })
}

function pickSaleStatus(status: 'SELLING' | 'SOLDOUT' | 'HIDDEN', event: Event) {
  event.preventDefault()
  syncSaleStatusRadios()
  if (props.saleStatus === status) return
  emit('update-status', status)
}

watch(
  () => props.saleStatus,
  async () => {
    await nextTick()
    syncSaleStatusRadios()
  },
)

const form = props.form
const fileInput = ref<HTMLInputElement | null>(null)
const uploading = ref(false)
const blockImageKey = ref<number | 'new' | null>(null)
const detailDragOver = ref(false)
const maxImages = MAX_PRODUCT_IMAGES
const leadTimes = LEAD_TIMES
const mallKind = computed<MallKind>({
  get() {
    return form.mallKind === 'REGULAR' ? 'REGULAR' : 'SALE'
  },
  set(value) {
    form.saleCode = ''
    /* 공동구매몰 신규 등록은 잠시 막는다. 이미 공동구매인 상품은 구분을 유지한다. */
    if (value === 'SALE') return
    form.mallKind = 'REGULAR'
    form.orderStep = 1
    form.minOrder = 1
  },
})

const originKinds = ORIGIN_KIND_OPTIONS
const originMust = computed(() => originRequiredFor(form.category))
const originKind = computed<OriginKind>({
  get: () => form.originKind || '',
  set(value) {
    if (form.originKind !== value) form.originDetail = ''
    form.originKind = value
    form.origin = composeOrigin(form.originKind, form.originDetail)
  },
})
const originDetail = computed({
  get: () => form.originDetail,
  set(value: string) {
    form.originDetail = value
    form.origin = composeOrigin(form.originKind, form.originDetail)
  },
})
const originHint = computed(() =>
  originMust.value
    ? '식품·건강은 원산지를 골라야 검수를 요청할 수 있습니다. 수입산은 국가명, 혼합은 국가별 원산지를 적습니다.'
    : '이 분류는 원산지를 비워 둘 수 있습니다. 표시해야 하는 품목만 고르세요.',
)
const sellNoun = computed(() => sellUnitNoun(form.sellUnit))
const priceQty = computed(() => {
  const max = Math.trunc(Number(form.allocShipMax) || 0)
  if (max >= 1) return max
  return Math.trunc(Number(form.basisQty) || 0)
})
const shipQty = computed(() => Math.trunc(Number(form.allocShipMax) || 0))
/** 개수와 배송비 금액이 모두 있을 때만 공급가·판매가격을 적는다. 0원은 아직 안 적은 것이다. */
const shipLineReady = computed(() => shipQty.value >= 1 && Number(form.allocShipFee) > 0)
const goodsPriceLabel = computed(() => (shipQty.value >= 1 ? `${shipQty.value}개 ` : ''))
/** 공급가와 판매가격이 모두 있을 때만 구매 옵션을 고친다. */
const optionsReady = computed(
  () => shipLineReady.value && Number(form.basisCost) > 0 && Number(form.basisPrice) > 0,
)
const cartonPieces = computed(() => Math.max(1, Math.trunc(Number(form.packQty) || 1)))
const cartonPriceText = computed(() => money(Math.max(0, sellingPrice.value) * cartonPieces.value))
const sellingPrice = computed(() => Math.max(0, Number(form.price) || 0))
const priceText = computed(() => money(sellingPrice.value))
const customQty = ref<number | ''>('')

function money(value: number) {
  return `${Math.round(value).toLocaleString('ko-KR')}원`
}

function bundleTotal(opt: EditorOption) {
  return Math.max(0, sellingPrice.value + (Number(opt.extra) || 0))
}

/** 개당마진 = (개당판매가 - (개당공급가 + 배송비)) / 2 */
function optionBreakdown(qty: number, total: number) {
  const quoted = quoteOf(qty)
  if (!quoted) return null
  const unitSell = Math.round(total / qty)
  const unitSupply = Math.round(quoted.goodsCost / qty)
  const unitShip = quoted.unitShip
  const unitMargin = Math.round((unitSell - (unitSupply + unitShip)) / 2)
  return { unitSupply, unitShip, unitSell, unitMargin }
}

function bundleNote(qty: number | null, total: number) {
  if (qty === 1) return '1개 기준가와 같습니다'
  if (!qty) return '개수로 시작하는 이름만 묶음으로 계산합니다'
  return `개당 ${money(Math.round(total / qty))}`
}

const qtyRows = computed(() =>
  form.options
    .filter((opt) => opt.use !== false && opt.name.trim())
    .map((opt) => {
      const qty = optionPieceCount(opt.name)
      const total = bundleTotal(opt)
      return {
        opt,
        qty,
        total,
        note: bundleNote(qty, total),
        breakdown: qty ? optionBreakdown(qty, total) : null,
      }
    })
    .sort((a, b) => (a.qty ?? 9999) - (b.qty ?? 9999) || a.opt.name.localeCompare(b.opt.name, 'ko')),
)

function hasQty(count: number) {
  return form.options.some((opt) => opt.use !== false && optionPieceCount(opt.name) === count)
}

function setFront(opt: EditorOption) {
  if (!optionsReady.value) return
  for (const row of form.options) row.front = row.key === opt.key
}

function addQty(raw: number | '') {
  if (!optionsReady.value) return
  const count = Math.floor(Number(raw) || 0)
  if (count < 1) {
    emit('notify', '1개 이상부터 넣을 수 있습니다.')
    return
  }
  if (count > 999) return
  if (hasQty(count)) return
  const unit = sellingPrice.value
  const quoted = quoteOf(count)
  const group =
    form.options.find((opt) => opt.use !== false && opt.name.trim())?.group.trim() || '구성'
  const alone = !form.options.some((opt) => opt.use !== false && opt.name.trim())
  let extra = count === 1 ? 0 : unit * (count - 1)
  if (quoted && count === 1 && !quoteHold) {
    form.price = quoted.recommended
    extra = 0
  } else if (quoted && count !== 1) {
    extra = quoted.recommended - unit
  }
  form.options.push({
    key: nextRowKey(),
    group,
    name: `${count}개`,
    extra,
    stock: 0,
    use: true,
    front: alone,
    priceLocked: false,
  })
  customQty.value = ''
}

const quoteInput = computed(() => ({
  basisQty: priceQty.value,
  basisCost: Math.round(Number(form.basisCost) || 0),
  basisPrice: Math.round(Number(form.basisPrice) || 0),
  shipFee: Math.round(Number(form.allocShipFee) || 0),
  shipMax: Math.trunc(Number(form.allocShipMax) || 0),
}))

const quoteReady = computed(() => packQuoteReady(quoteInput.value))

function quoteOf(qty: number | null): PackQuote | null {
  if (!qty || qty < 1) return null
  return quotePack(qty, quoteInput.value)
}

let quoteHold = false

function setOptionTotal(opt: EditorOption, total: number) {
  const qty = optionPieceCount(opt.name)
  if (qty === 1) {
    form.price = total
    opt.extra = 0
    return
  }
  opt.extra = total - sellingPrice.value
}

function applyQuoteToOptions() {
  quoteHold = true
  for (const opt of form.options) {
    if (opt.use === false) continue
    const qty = optionPieceCount(opt.name)
    if (!qty) continue
    const quoted = quoteOf(qty)
    if (!quoted) continue
    opt.priceLocked = false
    opt.extra = qty === 1 ? 0 : quoted.recommended - sellingPrice.value
  }
  nextTick(() => {
    quoteHold = false
  })
}

function fillSuggestedPrices() {
  if (!optionsReady.value) {
    emit('notify', '개당 배송비와 그 수량의 공급가, 판매가격을 먼저 입력해 주세요.')
    return
  }
  syncQuotePrices()
  const maxQty = quoteInput.value.shipMax || quoteInput.value.basisQty
  for (const count of suggestPackQtys(maxQty)) {
    if (!hasQty(count)) addQty(count)
  }
  applyQuoteToOptions()
}

function recalculateOptions() {
  if (!optionsReady.value) {
    emit('notify', '개당 배송비와 그 수량의 공급가, 판매가격을 먼저 입력해 주세요.')
    return
  }
  const live = form.options.some((opt) => opt.use !== false && optionPieceCount(opt.name))
  if (!live) {
    emit('notify', '계산할 옵션이 없습니다. 개수를 추가하세요.')
    return
  }
  syncQuotePrices()
  applyQuoteToOptions()
}

function onBundlePrice(opt: EditorOption, total: number) {
  if (!optionsReady.value) return
  opt.priceLocked = true
  setOptionTotal(opt, Math.max(0, Math.round(Number(total) || 0)))
}

const previewTab = ref<'card' | 'buy'>('card')

const previewProduct = computed(() => {
  const product = toPreviewProduct(form, {
    storeName: props.storeName,
    storeCutoff: props.storeShipping.cutoff,
    storeReturnFee: props.storeShipping.returnFee,
    storeReturnPolicy: props.storeShipping.returnPolicy,
  })
  product.soldOut = props.saleStatus === 'SOLDOUT' || (product.stock ?? 0) <= 0
  return product
})

function removeOption(opt: EditorOption) {
  if (!optionsReady.value) return
  const index = form.options.findIndex((row) => row.key === opt.key)
  if (index >= 0) form.options.splice(index, 1)
}

function removeImage(index: number) {
  form.images.splice(index, 1)
}

function pickImages() {
  if (uploading.value) return
  blockImageKey.value = null
  fileInput.value?.click()
}

function pickBlockImage(key: number) {
  if (uploading.value) return
  blockImageKey.value = key
  fileInput.value?.click()
}

function addDetailImages() {
  if (uploading.value) return
  blockImageKey.value = 'new'
  fileInput.value?.click()
}

function onDetailDrop(event: DragEvent) {
  detailDragOver.value = false
  const files = Array.from(event.dataTransfer?.files ?? []).filter((file) => file.type.startsWith('image/'))
  if (!files.length || uploading.value) return
  void uploadDetailImages(files)
}

function blockLabel(type: MallDetailBlock['type']) {
  return BLOCK_LABEL[type]
}

function addBlock(type: MallDetailBlock['type']) {
  form.blocks.push({ key: nextRowKey(), type, text: '', imageUrl: '', alt: '' })
}

function moveBlock(index: number, step: number) {
  const next = index + step
  if (next < 0 || next >= form.blocks.length) return
  const [moved] = form.blocks.splice(index, 1)
  form.blocks.splice(next, 0, moved)
}

function removeBlock(index: number) {
  form.blocks.splice(index, 1)
}

async function onFiles(event: Event) {
  const input = event.target as HTMLInputElement
  const files = Array.from(input.files || [])
  input.value = ''
  const target = blockImageKey.value
  blockImageKey.value = null
  if (!files.length) return
  if (target === 'new') {
    await uploadDetailImages(files)
    return
  }
  const room = target == null ? maxImages - form.images.length : 1
  if (room <= 0) {
    emit('notify', `이미지는 ${maxImages}장까지 올릴 수 있습니다.`)
    return
  }
  uploading.value = true
  try {
    const uploaded = await props.uploader(files.slice(0, room))
    if (typeof target === 'number') {
      const block = form.blocks.find((item) => item.key === target)
      if (block && uploaded[0]?.url) block.imageUrl = uploaded[0].url
      return
    }
    for (const image of uploaded) {
      if (image.url && form.images.length < maxImages) form.images.push(image.url)
    }
  } catch (error) {
    emit('notify', error instanceof Error ? error.message : '이미지를 올리지 못했습니다.')
  } finally {
    uploading.value = false
  }
}

async function uploadDetailImages(files: File[]) {
  if (!files.length || uploading.value) return
  uploading.value = true
  try {
    const uploaded = await props.uploader(files.slice(0, 20))
    let count = 0
    for (const image of uploaded) {
      if (!image.url) continue
      form.blocks.push({ key: nextRowKey(), type: 'IMAGE', text: '', imageUrl: image.url, alt: '' })
      count += 1
    }
    if (count) emit('notify', `본문 이미지 ${count}장을 올렸습니다.`)
  } catch (error) {
    emit('notify', error instanceof Error ? error.message : '이미지를 올리지 못했습니다.')
  } finally {
    uploading.value = false
  }
}

function lockFreeShipping() {
  if (form.shippingFee !== 0) form.shippingFee = 0
  if (form.shippingCharge !== 'ONCE') form.shippingCharge = 'ONCE'
}

let syncingQuote = false

function syncQuotePrices() {
  const max = Math.trunc(Number(form.allocShipMax) || 0)
  if (max >= 1 && Math.trunc(Number(form.basisQty) || 0) !== max) form.basisQty = max
  if (mallKind.value === 'SALE' || syncingQuote || !quoteReady.value) return
  const unit = quoteOf(1)
  if (!unit) return
  syncingQuote = true
  quoteHold = true
  const prev = Math.max(0, Number(form.price) || 0)
  form.cost = unit.goodsCost
  form.price = unit.recommended
  for (const opt of form.options) {
    if (opt.use === false) continue
    const qty = optionPieceCount(opt.name)
    if (!qty) continue
    if (qty === 1) {
      opt.extra = 0
      continue
    }
    if (opt.priceLocked) {
      opt.extra = Math.round(prev + (Number(opt.extra) || 0)) - unit.recommended
    } else {
      const quoted = quoteOf(qty)
      if (quoted) opt.extra = quoted.recommended - unit.recommended
    }
  }
  syncingQuote = false
  nextTick(() => {
    quoteHold = false
  })
}

watch(
  () => [form.allocShipMax, form.allocShipFee, form.basisCost, form.basisPrice] as const,
  () => {
    syncQuotePrices()
  },
)

watch(() => form.shippingFee, lockFreeShipping)
watch(() => form.shippingCharge, lockFreeShipping)

watch(
  () => form.packQty,
  () => {
    if (mallKind.value !== 'SALE') return
    applySaleCarton(form)
  },
)

watch(sellingPrice, (next, prev) => {
  if (quoteHold || prev == null || next === prev) return
  for (const opt of form.options) {
    const qty = optionPieceCount(opt.name)
    if (qty === 1) {
      opt.extra = 0
      continue
    }
    const extra = Number(opt.extra) || 0
    if (prev <= 0 && extra === 0 && qty && qty > 1) {
      opt.extra = next * (qty - 1)
      continue
    }
    opt.extra = Math.round(prev + extra) - next
  }
})

watch(
  () => `${mallKind.value}|${form.options.map((opt) => `${opt.name}:${opt.use}`).join(',')}`,
  () => {
    if (mallKind.value !== 'REGULAR') return
    const live = form.options.filter((opt) => opt.use !== false && opt.name.trim())
    const pieces = live.filter((opt) => optionPieceCount(opt.name) != null)
    if (pieces.length && pieces.length === live.length && !pieces.some((opt) => opt.front)) {
      pieces[0].front = true
    }
    if (!pieces.length || pieces.length !== live.length) return
    for (const opt of pieces) {
      if (opt.stock) opt.stock = 0
    }
  },
  { immediate: true },
)

onMounted(() => {
  lockFreeShipping()
  form.marginShare = DEFAULT_MARGIN_SHARE
  if (form.mallKind !== 'REGULAR' && form.mallKind !== 'SALE') {
    form.mallKind = 'REGULAR'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["preg", [__props.tone === 'admin' ? 'preg--admin' : 'preg--seller', { 'preg--sale': mallKind.value === 'SALE' }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.isNew ? '상품 등록' : '상품 수정'), 1),
        _cache[27] || (_cache[27] = _createElementVNode("p", { class: "preg__lead" }, "새로운 상품을 등록하고, 쇼핑몰에 노출할 수 있습니다.", -1))
      ]),
      _createElementVNode("section", _hoisted_4, [
        _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "preg__card-title" }, "상품 기본 정보", -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "preg__label" }, [
            _createTextVNode("판매 구분 "),
            _createElementVNode("em", null, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", {
              class: _normalizeClass(["preg__kind", { 'is-on': mallKind.value === 'REGULAR' }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mallKind).value = $event)),
                type: "radio",
                value: "REGULAR"
              }, null, 512), [
                [_vModelRadio, mallKind.value]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("strong", null, "상시몰", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("span", null, "항상 판매", -1))
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["preg__kind preg__kind--sale is-locked", { 'is-on': mallKind.value === 'SALE' }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mallKind).value = $event)),
                type: "radio",
                value: "SALE",
                disabled: ""
              }, null, 512), [
                [_vModelRadio, mallKind.value]
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("strong", null, "공동구매몰", -1)),
              _cache[31] || (_cache[31] = _createElementVNode("span", null, "잠시 등록 중단", -1))
            ], 2)
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("p", { class: "preg__hint" }, "지금은 공동구매몰에 상품을 올릴 수 없습니다. 상시몰만 등록됩니다.", -1)),
          (mallKind.value === 'REGULAR')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 1개 판매가는 묶음 금액을 계산하는 기준입니다. 쇼핑몰에는 아래에서 고른 구성의 총액이 먼저 보입니다. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, "이미 공동구매인 상품만 그 구분을 유지합니다. 새로 공동구매로 바꾸지는 못합니다."))
        ]),
        _createElementVNode("label", _hoisted_9, [
          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "preg__label" }, [
            _createTextVNode("상품명 "),
            _createElementVNode("em", null, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).name) = $event)),
            class: "preg__input",
            maxlength: "150",
            placeholder: "예: [본사정품] 올인원 멀티비타민 이뮨샷 7개입, 8박스"
          }, null, 512), [
            [_vModelText, _unref(form).name]
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "preg__hint" }, "고객이 보는 제목입니다. 개수·박스·회분은 상품명에 직접 적으세요.", -1))
        ]),
        _createElementVNode("label", _hoisted_10, [
          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "preg__label" }, [
            _createTextVNode("카테고리 "),
            _createElementVNode("em", null, "*")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).category) = $event)),
            class: "preg__input"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (cat) => {
              return (_openBlock(), _createElementBlock("option", {
                key: cat,
                value: cat
              }, _toDisplayString(cat), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(form).category]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _cache[37] || (_cache[37] = _createTextVNode("원산지 ", -1)),
            (originMust.value)
              ? (_openBlock(), _createElementBlock("em", _hoisted_14, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(originKinds), (item) => {
              return (_openBlock(), _createElementBlock("label", {
                key: item.id || 'none',
                class: "preg__radio"
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((originKind).value = $event)),
                  type: "radio",
                  value: item.id
                }, null, 8, _hoisted_16), [
                  [_vModelRadio, originKind.value]
                ]),
                _createTextVNode(" " + _toDisplayString(item.label), 1)
              ]))
            }), 128))
          ]),
          (originKind.value === 'IMPORT')
            ? (_openBlock(), _createElementBlock("label", _hoisted_17, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "preg__label" }, [
                  _createTextVNode("국가명 "),
                  _createElementVNode("em", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((originDetail).value = $event)),
                  class: "preg__input",
                  maxlength: "60",
                  placeholder: "예: 미국",
                  "aria-label": "수입 국가명"
                }, null, 512), [
                  [_vModelText, originDetail.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (originKind.value === 'MIXED')
            ? (_openBlock(), _createElementBlock("label", _hoisted_18, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "preg__label" }, [
                  _createTextVNode("국가별 원산지 "),
                  _createElementVNode("em", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((originDetail).value = $event)),
                  class: "preg__input preg__textarea",
                  rows: "2",
                  maxlength: "160",
                  placeholder: "예: 쌀 국내산, 밀 미국산",
                  "aria-label": "국가별 원산지"
                }, null, 512), [
                  [_vModelText, originDetail.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (originKind.value === 'OTHER')
            ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "preg__label" }, [
                  _createTextVNode("원산지 내용 "),
                  _createElementVNode("em", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((originDetail).value = $event)),
                  class: "preg__input",
                  maxlength: "80",
                  placeholder: "표시할 원산지를 적으세요",
                  "aria-label": "기타 원산지"
                }, null, 512), [
                  [_vModelText, originDetail.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_20, _toDisplayString(originHint.value), 1)
        ]),
        (__props.canEditStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _cache[41] || (_cache[41] = _createElementVNode("span", { class: "preg__label" }, [
                _createTextVNode("상품 상태 "),
                _createElementVNode("em", null, "*")
              ], -1)),
              _createElementVNode("div", {
                ref_key: "statusRadioRoot",
                ref: statusRadioRoot,
                class: "preg__radios",
                role: "radiogroup",
                "aria-label": "상품 상태"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(saleStatusChoices, (item) => {
                  return _createElementVNode("label", {
                    key: item.value,
                    class: "preg__radio"
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: statusRadioName,
                      value: item.value,
                      checked: __props.saleStatus === item.value,
                      onClick: ($event: any) => (pickSaleStatus(item.value, $event)),
                      onKeydown: _withKeys(($event: any) => (pickSaleStatus(item.value, $event)), ["space"])
                    }, null, 40, _hoisted_22),
                    _createTextVNode(" " + _toDisplayString(item.label), 1)
                  ])
                }), 64))
              ], 512)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_23, [
          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "preg__label" }, "상품 설명", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).description) = $event)),
            class: "preg__input preg__textarea",
            maxlength: "4000",
            rows: "5",
            placeholder: "상품을 짧게 소개하세요."
          }, null, 512), [
            [_vModelText, _unref(form).description]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[45] || (_cache[45] = _createElementVNode("span", { class: "preg__label" }, "상품 이미지", -1)),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).images, (url, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: url + index,
                class: "preg__image"
              }, [
                _createElementVNode("img", {
                  src: url,
                  alt: ""
                }, null, 8, _hoisted_26),
                (index === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "대표 이미지"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "preg__image-del",
                  "aria-label": "이미지 삭제",
                  onClick: ($event: any) => (removeImage(index))
                }, " × ", 8, _hoisted_28)
              ]))
            }), 128)),
            (_unref(form).images.length < _unref(maxImages))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "preg__image preg__image--add",
                  disabled: uploading.value,
                  onClick: pickImages
                }, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", null, "+", -1)),
                  _cache[44] || (_cache[44] = _createTextVNode(" 이미지 추가 ", -1)),
                  _createElementVNode("small", null, "(최대 " + _toDisplayString(_unref(maxImages)) + "장)", 1)
                ], 8, _hoisted_29))
              : _createCommentVNode("", true)
          ]),
          _cache[46] || (_cache[46] = _createElementVNode("p", { class: "preg__note" }, "권장 이미지 사이즈 800 × 800px 이상 · 파일 형식 JPG, PNG (최대 10MB)", -1)),
          _createElementVNode("input", {
            ref_key: "fileInput",
            ref: fileInput,
            type: "file",
            accept: "image/jpeg,image/png,image/webp,image/gif",
            multiple: "",
            hidden: "",
            onChange: onFiles
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _cache[47] || (_cache[47] = _createElementVNode("span", { class: "preg__label" }, [
            _createTextVNode("재고 수량 "),
            _createElementVNode("em", null, "*")
          ], -1)),
          (__props.stockLocked)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", _hoisted_31, "재고 " + _toDisplayString(_unref(form).stock.toLocaleString('ko-KR')) + _toDisplayString(sellNoun.value), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "preg__text-btn",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('open-stock-history')))
                }, "재고·이력에서 추가")
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).stock) = $event)),
                  class: "preg__input",
                  type: "number",
                  min: "0"
                }, null, 512), [
                  [
                    _vModelText,
                    _unref(form).stock,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("em", null, _toDisplayString(sellNoun.value), 1)
              ]))
        ])
      ]),
      _createElementVNode("section", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[49] || (_cache[49] = _createElementVNode("h3", { class: "preg__card-title" }, "상세 정보", -1)),
          _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(form).blocks.length) + "개", 1)
        ]),
        _cache[53] || (_cache[53] = _createElementVNode("p", { class: "preg__hint" }, "올린 이미지가 상품 화면 본문에 위에서부터 순서대로 보입니다.", -1)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["preg__drop", { 'is-over': detailDragOver.value }]),
          disabled: uploading.value,
          onClick: addDetailImages,
          onDragover: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (detailDragOver.value = true), ["prevent"])),
          onDragleave: _cache[12] || (_cache[12] = ($event: any) => (detailDragOver.value = false)),
          onDrop: _withModifiers(onDetailDrop, ["prevent"])
        }, [
          _createVNode(AppIcon, {
            icon: uploading.value ? 'mdi-progress-upload' : 'mdi-tray-arrow-up',
            size: 28
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(uploading.value ? '이미지를 올리는 중입니다' : '본문 이미지 올리기'), 1),
          _cache[50] || (_cache[50] = _createElementVNode("small", null, "클릭하거나 이미지를 끌어다 놓으세요. 여러 장 가능", -1))
        ], 42, _hoisted_36),
        (!_unref(form).blocks.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_37, "이미지가 본문입니다. 글이 필요하면 소제목·문단·안내를 아래에 더합니다."))
          : (_openBlock(), _createElementBlock("ol", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).blocks, (block, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: block.key,
                  class: "preg__block"
                }, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("strong", null, _toDisplayString(blockLabel(block.type)), 1),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "위로",
                        disabled: index === 0,
                        onClick: ($event: any) => (moveBlock(index, -1))
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-arrow-up",
                          size: 16
                        })
                      ], 8, _hoisted_41),
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "아래로",
                        disabled: index === _unref(form).blocks.length - 1,
                        onClick: ($event: any) => (moveBlock(index, 1))
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-arrow-down",
                          size: 16
                        })
                      ], 8, _hoisted_42),
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "블록 삭제",
                        onClick: ($event: any) => (removeBlock(index))
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-trash-can-outline",
                          size: 16
                        })
                      ], 8, _hoisted_43)
                    ])
                  ]),
                  (block.type === 'HEADING')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => ((block.text) = $event),
                        class: "preg__input",
                        maxlength: "80",
                        placeholder: "소제목을 입력하세요"
                      }, null, 8, _hoisted_44)), [
                        [_vModelText, block.text]
                      ])
                    : (block.type === 'TEXT' || block.type === 'NOTICE')
                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                          key: 1,
                          "onUpdate:modelValue": ($event: any) => ((block.text) = $event),
                          class: "preg__input preg__textarea",
                          rows: block.type === 'NOTICE' ? 2 : 4,
                          maxlength: "2000",
                          placeholder: block.type === 'NOTICE' ? '안내 문구를 입력하세요' : '본문 문단을 입력하세요'
                        }, null, 8, _hoisted_45)), [
                          [_vModelText, block.text]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          (!block.imageUrl)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "preg__drop preg__drop--slim",
                                disabled: uploading.value,
                                onClick: ($event: any) => (pickBlockImage(block.key))
                              }, [
                                _createVNode(AppIcon, {
                                  icon: "mdi-tray-arrow-up",
                                  size: 22
                                }),
                                _cache[51] || (_cache[51] = _createElementVNode("span", null, "이미지 올리기", -1))
                              ], 8, _hoisted_47))
                            : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("img", {
                                  src: block.imageUrl,
                                  alt: ""
                                }, null, 8, _hoisted_49)
                              ])),
                          _createElementVNode("div", _hoisted_50, [
                            (block.imageUrl)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "preg__upload-btn",
                                  disabled: uploading.value,
                                  onClick: ($event: any) => (pickBlockImage(block.key))
                                }, [
                                  _createVNode(AppIcon, {
                                    icon: "mdi-tray-arrow-up",
                                    size: 16
                                  }),
                                  _cache[52] || (_cache[52] = _createTextVNode(" 이미지 교체 ", -1))
                                ], 8, _hoisted_51))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((block.alt) = $event),
                              class: "preg__input",
                              maxlength: "150",
                              placeholder: "이미지 설명을 입력하세요"
                            }, null, 8, _hoisted_52), [
                              [_vModelText, block.alt]
                            ])
                          ])
                        ]))
                ]))
              }), 128))
            ])),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (addBlock('HEADING')))
          }, "소제목"),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (addBlock('TEXT')))
          }, "문단"),
          _createElementVNode("button", {
            type: "button",
            onClick: addDetailImages
          }, "이미지 올리기"),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (addBlock('NOTICE')))
          }, "안내")
        ])
      ]),
      _createElementVNode("section", _hoisted_54, [
        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "preg__card-head" }, [
          _createElementVNode("h3", { class: "preg__card-title" }, "배송 정보"),
          _createElementVNode("p", {
            class: "preg__ship-free",
            title: "고객에게 배송비를 따로 받지 않습니다. 판매가격에 포함합니다."
          }, "* 무료배송")
        ], -1)),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _cache[54] || (_cache[54] = _createElementVNode("span", { class: "preg__label" }, [
              _createTextVNode("출고 소요 "),
              _createElementVNode("em", null, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_57, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leadTimes), (lead) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: lead,
                  type: "button",
                  class: _normalizeClass({ 'is-on': _unref(form).leadTime === lead }),
                  onClick: ($event: any) => (_unref(form).leadTime = lead)
                }, _toDisplayString(lead), 11, _hoisted_58))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).leadTime) = $event)),
              class: "preg__input",
              type: "text",
              maxlength: "30",
              placeholder: "직접 입력",
              "aria-label": "출고 소요"
            }, null, 512), [
              [_vModelText, _unref(form).leadTime]
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_59, [
        _cache[67] || (_cache[67] = _createElementVNode("h3", { class: "preg__card-title" }, "가격 정보", -1)),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("span", _hoisted_63, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(form).allocShipMax) = $event)),
                  class: "preg__input",
                  type: "number",
                  min: "1",
                  "aria-label": "배송비 기준 수량"
                }, null, 512), [
                  [
                    _vModelText,
                    _unref(form).allocShipMax,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[56] || (_cache[56] = _createElementVNode("span", null, "개당 배송비", -1))
              ]),
              _createElementVNode("span", _hoisted_64, [
                _createVNode(WonInput, {
                  modelValue: _unref(form).allocShipFee,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(form).allocShipFee) = $event)),
                  "aria-label": "배송비"
                }, null, 8, ["modelValue"]),
                _cache[57] || (_cache[57] = _createElementVNode("span", null, "원", -1))
              ])
            ]),
            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "preg__hint" }, "고객에게는 무료배송입니다. 이 금액은 아래 판매가격에 넣고, 환불할 때도 같습니다.", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["preg__price-pair", { 'is-off': !shipLineReady.value }])
          }, [
            _createElementVNode("label", _hoisted_65, [
              _createElementVNode("span", _hoisted_66, _toDisplayString(goodsPriceLabel.value) + "공급가", 1),
              _createElementVNode("span", _hoisted_67, [
                _createVNode(WonInput, {
                  modelValue: _unref(form).basisCost,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(form).basisCost) = $event)),
                  disabled: !shipLineReady.value,
                  class: _normalizeClass({ 'is-zero': shipLineReady.value && !Number(_unref(form).basisCost) })
                }, null, 8, ["modelValue", "disabled", "class"]),
                _cache[59] || (_cache[59] = _createElementVNode("em", null, "원", -1))
              ])
            ]),
            _createElementVNode("label", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, _toDisplayString(goodsPriceLabel.value) + "판매가격", 1),
              _createElementVNode("span", _hoisted_70, [
                _createVNode(WonInput, {
                  modelValue: _unref(form).basisPrice,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(form).basisPrice) = $event)),
                  disabled: !shipLineReady.value,
                  class: _normalizeClass({ 'is-zero': shipLineReady.value && !Number(_unref(form).basisPrice) })
                }, null, 8, ["modelValue", "disabled", "class"]),
                _cache[60] || (_cache[60] = _createElementVNode("em", null, "원", -1))
              ])
            ])
          ], 2),
          (!shipLineReady.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_71, "개당 배송비 수량과 금액을 적으면 공급가와 판매가격을 쓸 수 있습니다."))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_72, [
          (mallKind.value === 'SALE')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("label", _hoisted_73, [
                  _cache[62] || (_cache[62] = _createElementVNode("span", { class: "preg__label" }, [
                    _createTextVNode("1카톤 개수 "),
                    _createElementVNode("em", null, "*")
                  ], -1)),
                  _createElementVNode("span", _hoisted_74, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(form).packQty) = $event)),
                      class: "preg__input",
                      type: "number",
                      min: "1",
                      disabled: !optionsReady.value
                    }, null, 8, _hoisted_75), [
                      [
                        _vModelText,
                        _unref(form).packQty,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[61] || (_cache[61] = _createElementVNode("em", null, "개", -1))
                  ]),
                  _cache[63] || (_cache[63] = _createElementVNode("span", { class: "preg__hint" }, " 한 카톤에 들어 있는 개수입니다. 목록에는 1개 가격이 먼저 보이고, 상품을 열면 카톤 가격과 이 개수 묶음이 보입니다. 최소 주문은 1카톤입니다. ", -1))
                ]),
                (sellingPrice.value > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_76, " 1개당 " + _toDisplayString(priceText.value) + " · 1카톤 " + _toDisplayString(cartonPriceText.value) + " · " + _toDisplayString(cartonPieces.value) + "개 묶음 ", 1))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["preg__opts", { 'is-off': !optionsReady.value }])
              }, [
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "preg__opts-head" }, [
                  _createElementVNode("strong", null, "구매 옵션"),
                  _createElementVNode("span", null, "동그라미로 고른 가격이 상품 목록에 보이고, 상품 화면에서는 그 옵션이 미리 선택됩니다.")
                ], -1)),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "preg__qty-make",
                    disabled: !optionsReady.value,
                    onClick: fillSuggestedPrices
                  }, " 자동옵션생성 ", 8, _hoisted_78),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: !optionsReady.value || !qtyRows.value.length,
                    onClick: recalculateOptions
                  }, " 자동계산 ", 8, _hoisted_79),
                  _createElementVNode("label", _hoisted_80, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((customQty).value = $event)),
                      type: "number",
                      min: "1",
                      "aria-label": "추가할 개수",
                      disabled: !optionsReady.value
                    }, null, 8, _hoisted_81), [
                      [
                        _vModelText,
                        customQty.value,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[64] || (_cache[64] = _createElementVNode("em", null, "개", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: !optionsReady.value,
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (addQty(customQty.value)))
                    }, "추가", 8, _hoisted_82)
                  ])
                ]),
                (!optionsReady.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_83, "공급가와 판매가격을 모두 적으면 구매 옵션을 쓸 수 있습니다."))
                  : (!qtyRows.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_84, "아직 옵션이 없습니다. 개수를 적고 추가하거나 자동옵션생성을 누르세요."))
                    : _createCommentVNode("", true),
                (qtyRows.value.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_85, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qtyRows.value, (row) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: row.opt.key,
                          class: _normalizeClass(["preg__qty-row", { 'is-front': row.opt.front }])
                        }, [
                          _createElementVNode("label", _hoisted_86, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "preg-storefront",
                              checked: row.opt.front === true,
                              disabled: !optionsReady.value,
                              "aria-label": `${row.opt.name}을 상품 목록에 표시`,
                              onChange: ($event: any) => (setFront(row.opt))
                            }, null, 40, _hoisted_87)
                          ]),
                          _createElementVNode("strong", null, _toDisplayString(row.opt.name), 1),
                          _createElementVNode("label", _hoisted_88, [
                            _createVNode(WonInput, {
                              "model-value": row.total,
                              disabled: !optionsReady.value,
                              "aria-label": `${row.opt.name} 판매가격`,
                              "onUpdate:modelValue": ($event: any) => (onBundlePrice(row.opt, $event))
                            }, null, 8, ["model-value", "disabled", "aria-label", "onUpdate:modelValue"]),
                            _cache[65] || (_cache[65] = _createElementVNode("em", null, "원", -1)),
                            (row.opt.front)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_89, "목록에 표시"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "preg__text-btn",
                            disabled: !optionsReady.value,
                            "aria-label": `${row.opt.name} 삭제`,
                            onClick: ($event: any) => (removeOption(row.opt))
                          }, " 삭제 ", 8, _hoisted_90),
                          (row.breakdown)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                                _createElementVNode("span", null, "개당공급가 " + _toDisplayString(money(row.breakdown.unitSupply)), 1),
                                _createElementVNode("span", null, "배송비 " + _toDisplayString(money(row.breakdown.unitShip)), 1),
                                _createElementVNode("span", null, "개당판매가 " + _toDisplayString(money(row.breakdown.unitSell)), 1),
                                _createElementVNode("span", null, "개당마진 " + _toDisplayString(money(row.breakdown.unitMargin)), 1)
                              ]))
                            : (row.qty)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_92, " 개당판매가 " + _toDisplayString(money(Math.round(row.total / row.qty))), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(row.note), 1))
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
        ]),
        _createElementVNode("p", _hoisted_94, "마진배분율 : " + _toDisplayString(_unref(DEFAULT_MARGIN_SHARE)) + "%", 1)
      ]),
      _createElementVNode("section", _hoisted_95, [
        _cache[69] || (_cache[69] = _createElementVNode("h3", { class: "preg__card-title" }, "관리자 메모", -1)),
        _createElementVNode("label", _hoisted_96, [
          _cache[68] || (_cache[68] = _createElementVNode("span", { class: "preg__label" }, "검수에 남길 말", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(form).requestNote) = $event)),
            class: "preg__input preg__textarea",
            rows: "3",
            maxlength: "500",
            placeholder: "검수 때 참고할 말을 남기세요. 선택입니다."
          }, null, 512), [
            [_vModelText, _unref(form).requestNote]
          ])
        ])
      ])
    ]),
    _createElementVNode("aside", _hoisted_97, [
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("button", {
          type: "button",
          role: "tab",
          class: _normalizeClass(["preg__preview-tab", { 'is-on': previewTab.value === 'card' }]),
          "aria-selected": previewTab.value === 'card',
          onClick: _cache[25] || (_cache[25] = ($event: any) => (previewTab.value = 'card'))
        }, " 목록 카드 ", 10, _hoisted_99),
        _createElementVNode("button", {
          type: "button",
          role: "tab",
          class: _normalizeClass(["preg__preview-tab", { 'is-on': previewTab.value === 'buy' }]),
          "aria-selected": previewTab.value === 'buy',
          onClick: _cache[26] || (_cache[26] = ($event: any) => (previewTab.value = 'buy'))
        }, " 구매 화면 ", 10, _hoisted_100)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_101, [
        _createVNode(ProductCard, {
          product: previewProduct.value,
          mode: "static"
        }, null, 8, ["product"])
      ], 512), [
        [_vShow, previewTab.value === 'card']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_102, [
        _createVNode(MallProductBuyPanel, { product: previewProduct.value }, null, 8, ["product"])
      ], 512), [
        [_vShow, previewTab.value === 'buy']
      ])
    ])
  ], 2))
}
}

})